<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap fixed">
      <v-col cols="12" class="icon-title word-type pb-5"
        ><icon-application-cancel :width="24" :height="24" />휴일사전대체
        취소신청
      </v-col>
      <v-col cols="12" class="pt-0 pb-3 px-6 title-desc">
        <v-chip label class="chip-desc" color="#E8F9ED">
          <span>취소할 신청서를 선택해 주세요</span>
        </v-chip>
      </v-col>
    </v-row>

    <!-- 목록 -->
    <hol-replacel-list
      class="overflow-y-auto"
      :searchReqGubun="tabGubun.tab1"
    />
  </div>
</template>

<script>
import HolReplacelList from '@/components/allDoc/HolReplacelList.vue';
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue';

export default {
  data: () => ({
    tab: null,
    tabGubun: {
      tab1: 'MYDOC', // 내문서
      //tab2: 'TEMP', // 임시저장문서
    },
  }),
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_NAV
      }px`;
    },
  },
  mounted() {
    this.$store.commit('ELA/RESET_ELA_STATE');
    this.$store.commit('SET_APPL_TYPE', 'parLeave');
  },
  components: {
    HolReplacelList,
    IconApplicationCancel,
  },
};
</script>

<style></style>
